<!-- //
上传文件对话框形态
@auth xuyd
@date 2022-09-10
//-->
<template>
  <el-dialog
      title="上传文件"
      :visible.sync="visible"
      :modal="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="true"
      top="10vh"
      width="400px">
    <Upload :form="form" :limit="limit" :multiple="multiple" :accept="accept"/>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="handleOk">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>

import Upload from './upload.vue'

export default {
  name: 'UploadDialog',
  components: {Upload},
  data() {
    return {
      visible: false,
      form: {
        fileList: [],
      },
      opts: {}
    }
  },

  props:{
    // 上传文件扩展名
    accept: {
      type : String,
      default: '.xls,.xlsx'
    },
    multiple: {
      type: Boolean, // 多选
      default: false,
    },
    size: {
      type: Number,
      default: 50,// 50MB
    },
    limit: {
      type: Number,
      default: 1,
    },
  },

  methods: {
    showModal({data, onOk}) {
      let that = this;
      data = data || {};
      return new Promise((resolve, reject) => {
        this.dialogShow({
          data: data,
          mode: data.mode,
          onOk(retData) {
            let promise = onOk && onOk(retData);
            if(promise) {
              promise.then(() => {
                that.hideModal();
              }).catch(err => {
                console.log(err)
              })
            }
          }
        })
      })
    },
    dialogShow(opts) {
      if(!opts.data) {
        opts.data = {}
      }
      this.opts = opts;
      this.visible = true;
    },
    hideModal() {
      this.visible = false;
      this.form.fileList = [];
    },
    handleOk() {
      console.log("-------handleOk-------->", this.form.fileList)
      if(!this.form.fileList || this.form.fileList.length <= 0) {
        this.$modal.msgWarning("请先上传文件");
        return;
      }
      this.opts.onOk(this.form);
    },
  },
}
</script>

<style lang="less" scoped>

</style>


